import React from "react";

import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';


const SumaryCard = ({ title, value, color, icon = false, icontransform = null }) => {
    return (
        <div sx={{ borderColor: '#051f34' }}>
            <div style={{ textAlign: "center", margin: "0 5px" }}>
                <div
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: color,
                        color: "#000",
                        fontWeight: "bold",
                        fontSize: 12,
                        border: '1px solid #051f34',
                        borderRadius: 5,
                        padding: "5px 5px",
                    }}
                >
                    {icon && (
                        <span style={{ marginRight: 4 }}>
                            <DownArrow icontransform={icontransform} />
                        </span>
                    )}
                    {value}
                </div>
                <div style={{ color: "#051f34", fontSize: 14 }}>
                    {title}
                </div>
            </div>
        </div>
    );
};

const DownArrow = (props) => (
    <span style={{ display: "inline-block", transform: "translateY(2px)" }}>
        <ArrowRightAltIcon style={{ fontSize: 20, color: "#051f34", transform: props.icontransform || 'none' }} />
    </span>
);


export default SumaryCard;